export enum TypInstytucji {
  WOJEWODA = 15,
  MARSZALEK = 16,
  WZOON = 0,
}
